import { createContext, useContext } from 'react';

/** 订单详情弹框只展示，不露出改单、履约、审批等操作 */
const OrderDetailViewOnlyContext = createContext(false);

export const OrderDetailViewOnlyProvider = OrderDetailViewOnlyContext.Provider;

export const useOrderDetailViewOnly = () => useContext(OrderDetailViewOnlyContext);
